import React from "react";
import "./Div3.css";

export const Div3 = () => {
  return (
    <div className="activity-div3">
      <div className="activity-div-block-container">
        <div className="activity-div3-left">
          <div className="activity-div3-img-container">
            <img src="" alt="" />
          </div>
          <div className="activity-div3-text-container">
            <span>Rural Development</span>
            <p>
              Development of Kalarabanka, Prof. Samanta’s native village, to
              smart Village
            </p>
          </div>
        </div>
        <div className="activity-div3-right">
          <div className="activity-div3-img-container">
            <img src="" alt="" />
          </div>
          <div className="activity-div3-text-container">
            <span>Rural Development</span>
            <p>
              Development of Kalarabanka, Prof. Samanta’s native village, to
              smart Village
            </p>
          </div>
        </div>
      </div>
      <div className="activity-div-block-container">
        <div className="activity-div3-left">
          <div className="activity-div3-img-container">
            <img src="" alt="" />
          </div>
          <div className="activity-div3-text-container">
            <span>Rural Development</span>
            <p>
              Development of Kalarabanka, Prof. Samanta’s native village, to
              smart Village
            </p>
          </div>
        </div>

        <div className="activity-div3-right">
          <div className="activity-div3-img-container">
            <img src="" alt="" />
          </div>
          <div className="activity-div3-text-container">
            <span>Rural Development</span>
            <p>
              Development of Kalarabanka, Prof. Samanta’s native village, to
              smart Village
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
